// Light-mode page background for the Home Hub — the white counterpart of HubDarkBackground.jsx.
// Used when the user's Home Page Background preference is 'light'. Same two fixed layers, pinned to
// the viewport so they never scroll with the tiles:
//   1. soft white-to-silver gradient, lightest at the top left and a touch cooler at the bottom right
//   2. the same contour waves as the dark background — clear space under the header first, then a
//      wide gap between the lines at the top that tightens as they cascade down the page — drawn in a
//      faint grey instead of white so they stay a quiet texture behind the tiles
// The wave settings below are deliberately identical to HubDarkBackground.jsx; if you change the wave
// spacing there, change it here too so the light and dark pages keep the same shape.

const BASE_GRADIENT = 'linear-gradient(165deg, #ffffff 0%, #f6f7f9 50%, #eceef2 100%)';

const WAVE_TILE_W = 240;
const WAVE_TILE_H = 1600;
const WAVE_START_Y = 230;
const WAVE_FIRST_GAP = 64;
const WAVE_GAP_RATIO = 0.93;
const WAVE_MIN_GAP = 9;
const WAVE_STROKE = '#1d1d1b';
const WAVE_STROKE_OPACITY = 0.06;

const buildWaves = () => {
  const paths = [];
  let y = WAVE_START_Y;
  let gap = WAVE_FIRST_GAP;
  while (y < WAVE_TILE_H) {
    // Bigger, lazier waves where the lines are far apart; gentler ripples where they are close.
    const amp = Math.max(2, Math.min(13, gap * 0.32));
    paths.push(`<path d='M0 ${y.toFixed(1)}Q60 ${(y - amp).toFixed(1)} 120 ${y.toFixed(1)}T${WAVE_TILE_W} ${y.toFixed(1)}'/>`);
    y += gap;
    gap = Math.max(WAVE_MIN_GAP, gap * WAVE_GAP_RATIO);
  }
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='${WAVE_TILE_W}' height='${WAVE_TILE_H}'><g fill='none' stroke='${WAVE_STROKE}' stroke-opacity='${WAVE_STROKE_OPACITY}'>${paths.join('')}</g></svg>`;
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
};

const WAVES = buildWaves();

// Soft fade-in over the first couple of lines so the waves ease in rather than start abruptly.
const WAVES_MASK = 'linear-gradient(to bottom, rgba(0,0,0,0) 0px, rgba(0,0,0,0) 200px, #000 330px, #000 100%)';

const HubLightBackground = () => (
  <>
    <div
      className="fixed inset-0 pointer-events-none"
      style={{ background: BASE_GRADIENT }}
      data-testid="hub-fixed-light-background"
    />
    <div
      className="fixed inset-0 pointer-events-none"
      style={{
        backgroundImage: WAVES,
        backgroundSize: `${WAVE_TILE_W}px ${WAVE_TILE_H}px`,
        backgroundRepeat: 'repeat-x',
        backgroundPosition: '0 0',
        WebkitMaskImage: WAVES_MASK,
        maskImage: WAVES_MASK,
      }}
      data-testid="hub-fixed-light-background-waves"
    />
  </>
);

export default HubLightBackground;
